import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import {
  PostToMaintenanceRequestMessageThread,
  PostToMaintenanceRequestMessageThreadVariables,
} from '../../../athena/types/PostToMaintenanceRequestMessageThread';

export const POST_TO_MAINTENANCE_REQUEST_MESSAGE_THREAD = gql`
  mutation PostToMaintenanceRequestMessageThread(
    $messageThreadId: String!
    $authorUserToken: String!
    $content: String!
  ) {
    webMaintenance {
      postToMessageThread(
        input: {
          messageThreadId: $messageThreadId
          authorUserToken: $authorUserToken
          content: $content
        }
      ) {
        _empty
      }
    }
  }
`;

export const usePostToMaintenanceRequestMessageThread = () => {
  return useMutation<
    PostToMaintenanceRequestMessageThread,
    PostToMaintenanceRequestMessageThreadVariables
  >(POST_TO_MAINTENANCE_REQUEST_MESSAGE_THREAD);
};
